/* OMOTOR 商品卡适配条 — 读车型选择器车库(localStorage omotor_garage_v1), 个性化每张卡的适配提示 */
(function () {
  'use strict';
  var GK = 'omotor_garage_v1';

  function garageVehicle() {
    try {
      var g = JSON.parse(localStorage.getItem(GK));
      if (g && g.a >= 0 && g.v && g.v[g.a] && g.v[g.a].tag) return g.v[g.a];
    } catch (e) {}
    return null;
  }

  function apply() {
    var veh = garageVehicle();
    if (!veh) return; // 没选过车: 保留服务端默认文案
    var bars = document.querySelectorAll('.om-fitbar[data-tags]:not([data-om-done])');
    for (var i = 0; i < bars.length; i++) {
      var b = bars[i];
      b.setAttribute('data-om-done', '1');
      var txt = b.querySelector('.om-fit-txt');
      if (!txt) continue;
      var tags = (b.getAttribute('data-tags') || '').split(',');
      var uni = b.classList.contains('om-fit-uni');
      var match = tags.indexOf(String(veh.tag).toLowerCase()) > -1;
      if (uni || match) {
        b.classList.add('om-fit-yes');
        txt.textContent = '✓ Fits your ' + veh.nm;
      } else {
        b.classList.remove('om-fit-yes');
        txt.textContent = '◇ Check fitment for ' + veh.nm;
      }
    }
  }

  function init() {
    apply();
    // Dawn 筛选/分页用 AJAX 替换商品网格, 监听新卡片出现
    var grid = document.getElementById('ProductGridContainer') || document.body;
    if (window.MutationObserver) {
      var t = null;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(apply, 120);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* OMOTOR 购物车 Better Together — 把商品页 FBT(omotor-product-pro) 的搭配结果嵌入 Essential Cart Drawer
   逻辑: 取购物车最新商品 → 抓其商品页 HTML 里 .opro-fbt-grp 的伙伴商品(互补逻辑与商品页完全一致)
   → 排除已在购物车的 → 取前2个 → /products/<handle>.js 拿变体/价格 → 渲染勾选+合计+一键加购 */
(function () {
  'use strict';
  var PORTAL = 'essential-cart-drawer-portal';
  var busy = false, lastKey = '';

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function fetchPartners(handle) {
    var ck = 'omfbt_' + handle;
    try { var c = sessionStorage.getItem(ck); if (c) return Promise.resolve(JSON.parse(c)); } catch (e) {}
    return fetch('/products/' + handle).then(function (r) { return r.text(); }).then(function (html) {
      var out = [], seen = {};
      var re = /<div class="opro-fbt-grp[^"]*"([^>]*)>([\s\S]*?)(?=<div class="opro-fbt-grp|<\/div>\s*<div class="opro-fbt-side)/g;
      var m;
      while ((m = re.exec(html)) && out.length < 8) {
        if (/data-cur/.test(m[1])) continue;
        var hm = /href="\/products\/([a-z0-9-]+)/.exec(m[2]);
        if (hm && !seen[hm[1]]) { seen[hm[1]] = 1; out.push(hm[1]); }
      }
      try { sessionStorage.setItem(ck, JSON.stringify(out)); } catch (e) {}
      return out;
    });
  }

  function productInfo(handle) {
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = null;
      for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { v = p.variants[i]; break; } }
      if (!v) return null;
      return { handle: handle, vid: v.id, title: p.title, price: v.price, cmp: v.compare_at_price, img: p.featured_image, url: p.url };
    }).catch(function () { return null; });
  }

  function render(host, anchor, items) {
    var old = document.getElementById('om-cart-fbt');
    if (old) old.remove();
    if (!items.length) return;
    var el = document.createElement('div');
    el.id = 'om-cart-fbt';
    var rows = items.map(function (p, i) {
      var cmp = p.cmp && p.cmp > p.price ? '<s>' + money(p.cmp) + '</s>' : '';
      return '<label class="omf-row" data-i="' + i + '">' +
        '<input type="checkbox" checked data-vid="' + p.vid + '" data-price="' + p.price + '">' +
        '<img src="' + p.img + '&width=120" width="44" height="44" loading="lazy" onerror="this.src=\'' + p.img + '\'">' +
        '<span class="omf-t">' + p.title.replace(/</g, '&lt;').slice(0, 70) + '</span>' +
        '<span class="omf-p">' + money(p.price) + ' ' + cmp + '</span></label>';
    }).join('');
    el.innerHTML = '<div class="omf-h">Better Together</div>' + rows +
      '<div class="omf-foot"><span class="omf-total"></span><button type="button" class="omf-add">Add to Cart</button></div>' +
      '<div class="omf-note">Free shipping on all items</div>';
    anchor.parentNode.insertBefore(el, anchor);

    function upd() {
      var cbs = el.querySelectorAll('input:checked');
      var t = 0; cbs.forEach(function (c) { t += +c.dataset.price; });
      el.querySelector('.omf-total').textContent = cbs.length ? '+ ' + money(t) : '';
      var btn = el.querySelector('.omf-add');
      btn.disabled = !cbs.length;
      btn.textContent = cbs.length > 1 ? 'Add ' + cbs.length + ' to Cart' : 'Add to Cart';
    }
    el.addEventListener('change', upd); upd();

    el.querySelector('.omf-add').addEventListener('click', function () {
      var ids = [].map.call(el.querySelectorAll('input:checked'), function (c) { return { id: +c.dataset.vid, quantity: 1 }; });
      if (!ids.length) return;
      var btn = el.querySelector('.omf-add'); btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids }) })
        .then(function () { lastKey = ''; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add to Cart'; });
    });
  }

  function run() {
    var portal = document.getElementById(PORTAL);
    if (!portal) return;
    var footer = portal.querySelector('[data-essential-cart-element=cart-drawer-footer]');
    if (!footer || busy) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) { var o = document.getElementById('om-cart-fbt'); if (o) o.remove(); lastKey = 'empty'; return; }
      var first = cart.items[0];
      var inCart = {}; cart.items.forEach(function (it) { inCart[it.handle] = 1; });
      var key = first.handle + '|' + cart.item_count;
      if (key === lastKey && document.getElementById('om-cart-fbt')) return;
      busy = true;
      fetchPartners(first.handle).then(function (handles) {
        var pick = handles.filter(function (h) { return !inCart[h]; }).slice(0, 2);
        return Promise.all(pick.map(productInfo));
      }).then(function (items) {
        items = items.filter(Boolean);
        var f2 = portal.querySelector('[data-essential-cart-element=cart-drawer-footer]');
        if (f2) { render(portal, f2, items); lastKey = key; }
      }).catch(function () {}).then(function () { busy = false; });
    }).catch(function () { busy = false; });
  }

  function init() {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 250); })
      .observe(document.body, { childList: true, subtree: true });
    run();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
